angular
	.module 'App.Directive'
	.directive 'wmMenu', ($http) ->
		restrict: 'EA'
		templateUrl: '@directive/menu/menu.view.html'
		controller: 'MenuController'
		link: ($scope) ->
			$http
				.get "/menu-structure.json"
				.then (menuStructure) ->
					$scope.menu = menuStructure.data
					$scope.menuLength = $scope.menu.length

class MenuController extends BaseController
	@register angular.module 'App.Directive'
	@inject '$scope',
		'$rootScope'
		'$state'
		'$transitions'
		'MessageTerminal'
		'UserInformation'
		'ConfigurationService'
		'termsAndConditionsUrl'
		'IntegrationRepository'

	initialize: ->
		@$scope.menuLevel = 1
		@$scope.angular = angular
		# Hide by default on mobile
		@$scope.showMenu = false

		@initializeRefresh()

	initializeRefresh: ->
		@$scope.$watch('menu',() => @initializeMenu())
		@MessageTerminal.on @$rootScope, @MessageTerminal.events.REFRESH, () => @refreshVisibility()
		@$transitions.onSuccess {}, () => @refreshActiveNodes()

	initializeMenu: ->
		if !@$scope.menu?
			return

		for node in @$scope.menu
			node.is_visible = @_isNodeVisible(node)
			node.is_active = @_isNodeActive(node)

	refreshVisibility: ->
		for node in @$scope.menu
			node.is_visible = @_isNodeVisible(node)

	refreshActiveNodes: ->
		if _.isEmpty(@$scope.menu)
			return

		for node in @$scope.menu
			node.is_active = @_isNodeActive(node)

	toggleMenu: ->
		@$scope.showMenu = !@$scope.showMenu

	getHref: (key) ->
		switch key
			when "support" then @ConfigurationService.get 'Backoffice.Setting.SupportUrl', true
			when "terms" then @termsAndConditionsUrl

	closeAllMenus: ->
		@$scope.showMenu = false
		angular
			.element(document)
			.find('header #menu .menu-open')
			.removeClass('menu-open')

		return

	toggleOpen: (event) ->
		event.stopPropagation()
		angular
			.element(event.target)
			.closest('.menu-leaf')
			.toggleClass('menu-open')

		return

	isVisibleForFiskaly: ->
		return @IntegrationRepository
			.getEntities()
			.then (integrations) ->
				return _.some integrations, (integration) ->
					return integration.id? && integration.id.indexOf('fiskaly_') == 0

	_isNodeVisible: (node) ->
		node.is_visible = true

		if node.visible_to_sub_user == false && @UserInformation.getSubUser()?
			node.is_visible = false

		if node.visibility_callback? && node.visibility_callback.indexOf('isVisible') == 0 && angular.isFunction(@[node.visibility_callback])
			node.is_visible = @[node.visibility_callback](node)

		if node.visible?
			node.is_visible = @ConfigurationService.isEnabled(node.visible)

			# Do not continue with sub_menu, as main node is not visible
			if !node.is_visible
				return false

		if node.sub_menu?
			node.is_visible = false

			for subNode in node.sub_menu
				if @_isNodeVisible(subNode)
					node.is_visible = true

		return node.is_visible

	_isNodeActive: (node) ->
		node.is_active = false

		if node.sub_menu?
			for subNode in node.sub_menu
				if @_isNodeActive(subNode)
					node.is_active = true
		else if node.active_states?
			for state in node.active_states
				if @$state.includes state
					node.is_active = true
		else if node.state?
			node.is_active = @$state.is node.state.replace(/\(.*?\)/, '')

		return node.is_active
